import type { Conversation } from 'lib-shared-legacy-types';
import { useContext, useMemo } from 'react';

import { ConversationContext } from 'components/conversation';

/** The text of the most recent inbound message, or '' when there is none. */
export const findLastInboundMessage = (conversation?: Conversation): string => {
  const events = conversation?.events || [];
  const messages = events.filter(
    (event) =>
      event.type === 'conversation:message_added' &&
      event.direction === 'inbound',
  );

  if (messages.length === 0) return '';
  if (!messages[messages.length - 1].text) return '';
  return messages[messages.length - 1].text as string;
};

/** Reads the last inbound message from the surrounding conversation. */
export const useLastInboundMessage = (): string => {
  const { conversation } = useContext(ConversationContext);

  return useMemo(() => findLastInboundMessage(conversation), [conversation]);
};
